import { Controller } from "@hotwired/stimulus";

// Polls the bulk Stripe sync progress endpoint. Reloads the page when the
// phase transitions to complete or failed. Polls every 2s during importing
// (fast, just a few API calls) and every 3s during matching.
export default class extends Controller {
  static values = {
    url: String,
    complete: { type: Boolean, default: false },
  };

  connect() {
    if (this.completeValue) return;
    this.poll();
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer);
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" },
      });
      const data = await response.json();

      if (data.phase === "importing" || data.phase === "matching") {
        const interval = data.phase === "importing" ? 2000 : 3000;
        this._timer = setTimeout(() => this.poll(), interval);
      } else if (data.phase === "complete" || data.phase === "failed") {
        window.location.reload();
      } else {
        // No sync running — stop polling
      }
    } catch {
      this._timer = setTimeout(() => this.poll(), 5000);
    }
  }
}
